import { Row, Col, Card } from "react-bootstrap";
import classNames from "classnames";
import { useState } from "react";
import BookCallModal from "../pages/billing/components/BookCallModal";
import { BILLING_PLANS } from "../pages/billing/constants/plans";

interface PricingCardProps {
  containerClass?: string;
  pricingCardClass?: string;
}

const PricingCard = ({
  containerClass,
  pricingCardClass,
}: PricingCardProps) => {
  const [show, setShow] = useState(false);

  return (
    <>
      <BookCallModal show={show} onHide={() => setShow(false)} />
      <Row className={containerClass}>
        {BILLING_PLANS.map((plan) => (
          <Col className="flex relative" key={plan.id}>
            <Card
              className={classNames("card-pricing", pricingCardClass, {
                "card-pricing-recommended": plan.isRecommended,
              })}
            >
              <Card.Body className="text-center px-1">
                <p
                  style={{ color: plan.nameColor }}
                  className="font-18 card-pricing-plan-name fw-bold text-uppercase"
                >
                  {plan.name}
                </p>
                <p className="italic font-12 h-[55px] pt-0 mt-0">
                  {plan.subtitle}
                </p>
                <button
                  className={classNames(
                    "btn",
                    "waves-effect",
                    "waves-light",
                    "mb-2",
                    "width-sm",
                    "postion-absolute",
                    plan.isRecommended ? "btn-light" : "btn-primary"
                  )}
                  onClick={() => setShow(true)}
                >
                  {plan.buttonText ?? "Book A Call"}
                </button>

                <ul className="card-pricing-features p-1 mt-3">
                  {plan.features.map((feature: string) => (
                    <li className="p-1 m-2 text-left" key={feature}>
                      {feature}
                    </li>
                  ))}
                </ul>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>
    </>
  );
};

export default PricingCard;
